module.exports = __webpack_public_path__ + "static/media/pic2.9352ef58.jpg";